import api from "../../../api/axios";

// Feature-local wrapper for the company join-request POST.
//
// Endpoint: POST /api/companies/{companyId}/join-requests/
// Body:     { message? }  — omit message entirely when empty (see
//                            migration/phase11-multi-field-plan.md §5.3).
// Auth:     IsAuthenticated.
// Response 201: CompanyJoinRequestSerializer payload.
// Errors:
//   403 — company is not open to join requests.
//   400 — already a member, unique_pending_join_request, serializer
//         field errors on `message`, or non_field_errors.
export const createJoinRequest = (companyId, body) =>
  api
    .post(`/companies/${companyId}/join-requests/`, body)
    .then((res) => res.data);
